<div nz-row [nzGutter]="[16, 16]">
	<div nz-col nzSpan="8">
		<nz-card nzTitle="Standard">
			<button nz-button nzType="primary" nzSize="large" (click)="showModal()">Show Modal</button>
			<nz-divider></nz-divider>
			Standard Modal, einfacher OK/Abbrechen Dialog, lässt sich nur über X oben rechts und Abbrechen Schließen. Buttontexte werden übersetzt.
			<nz-divider></nz-divider>
			Optionen: <br>
			<code ngNonBindable>
				<ul>
					<li>[nzMaskClosable] = "false"</li>
					<li>nzOkText = "{{ 'actions.OK' | translate }}"</li>
					<li>nzCancelText = "{{ 'actions.cancel' | translate }}"</li>
					<li>(nzOnOk) = "handleOk()"</li>
					<li>(nzOnCancel) = "handleCancel()"</li>
				</ul>
			</code>
		</nz-card>
	</div>
	<div nz-col nzSpan="8">
		<nz-card nzTitle="Nachrichten">
			<button nz-button (click)="info()">Info</button>
			<button nz-button (click)="success()">Success</button>
			<button nz-button (click)="error()">Error</button>
			<button nz-button (click)="warning()">Warning</button>
			<nz-divider></nz-divider>
			Nachrichtsboxen.
			Das Modal wird hier ebenfalls innerhalb der Komponente und dem Modalservice erzeugt.
			<nz-divider></nz-divider>
			Optionen: <br>
<pre ngNonBindable style="tab-size: 2">
constructor(private modal: NzModalService) &#123;&#125;

success(): void &#123;
	this.modal.success(&#123;
		nzTitle: 'This is a success message',
		nzContent: 'Nachrichten...Nachrichten...'
	&#125;);
&#125;
</pre>
		</nz-card>
	</div>
	<div nz-col nzSpan="8">
		<nz-card nzTitle="Eigener Footer">
			<button nz-button nzType="primary" (click)="createCustomButtonModal()">Custom Modal</button>
			<nz-divider></nz-divider>
			In diesem Modal befindet sich ein eigener Footer, der selbst erstellte buttons mit Funktionen enthält
			<nz-divider></nz-divider>
			Optionen: <br>
<pre ngNonBindable style="tab-size: 2">
const modal: NzModalRef = this.modal.create(&#123;
	nzTitle: 'custom button demo',
	nzContent: 'Eine Liste von Buttons mit verschiedenen Funktionen sind hier nun Teil des Footer',
	nzMaskClosable: false,
	nzFooter: [
		&#123;
			label: 'Close',
			shape: 'round',
			onClick: () => modal.destroy()
		&#125;,
		......
	]
&#125;);
</pre>
		</nz-card>
	</div>
	<div nz-col nzSpan="8">
	<nz-card nzTitle="Login Dialog">
		<div class="d-flex flex-column">
			<label nz-checkbox [(ngModel)]="forceCurrentUser">
				Erzwinge aktuellen Benutzer
			</label>
			<button nz-button nzType="primary" (click)="login()">
				Login
			</button>
		</div>
	</nz-card>
	</div>
</div>

<nz-modal
		[nzMaskClosable]="false"
		nzTitle="Test" (nzOnOk)="handleOk()"
		(nzOnCancel)="handleCancel()"
		[nzVisible]="modalVisible"
		nzOkText="{{ 'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
>
	Dieses Modal kann über das X oder {{ 'actions.cancel' | translate }} geschlossen werden, aber nicht über das klicken aus dem Modal heraus.
</nz-modal>

<nz-modal
		nzTitle="Test" (nzOnOk)="handleAlertOk()"
		(nzOnCancel)="handleAlertCancel()"
		[nzVisible]="modalAlertVisible"
		nzOkText="{{ 'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
>
	Dieses Modal kann über das X oder {{ 'actions.cancel' | translate }} geschlossen werden, und über einen Klick aus dem Modal heraus.
</nz-modal>
